import React from "react";
import { cn } from "../utils/siteActivityFormatters";

const tones = {
  sky: "from-sky-500/15 to-cyan-500/10 text-sky-700 dark:text-sky-300",
  emerald:
    "from-emerald-500/15 to-green-500/10 text-emerald-700 dark:text-emerald-300",
  violet:
    "from-violet-500/15 to-fuchsia-500/10 text-violet-700 dark:text-violet-300",
  amber:
    "from-amber-500/15 to-orange-500/10 text-amber-700 dark:text-amber-300",
  rose: "from-rose-500/15 to-red-500/10 text-rose-700 dark:text-rose-300",
  slate:
    "from-slate-500/15 to-slate-500/10 text-slate-700 dark:text-slate-300",
};

export default function StatCard({
  icon,
  label,
  value,
  subtitle,
  tone = "sky",
  pulse = false,
}) {
  return (
    <div
      className={cn(
        "rounded-[24px] border border-slate-200 bg-white p-4 shadow-sm transition dark:border-slate-800 dark:bg-slate-900",
        pulse && "ring-2 ring-rose-400/30"
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
            {label}
          </div>

          <div className="mt-2 truncate text-2xl font-bold text-[#123B57] dark:text-white">
            {value}
          </div>

          {subtitle && (
            <div className="mt-1 truncate text-xs font-medium text-slate-500 dark:text-slate-400">
              {subtitle}
            </div>
          )}
        </div>

        <div
          className={cn(
            "flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br",
            tones[tone] || tones.sky
          )}
        >
          {icon}
        </div>
      </div>
    </div>
  );
}